module.exports = "<div id=\"toasty\" class=\"toasty-position-bottom-right \" >\n<div class=\"toast toasty-theme-material\" *ngFor=\"let toast of toasts\" [ngClass]=\"toast.type\" >\n  <div class=\"close-button\" (click)=\"close(toast)\"></div>\n  <div class=\"toast-text\">\n    <span class=\"toast-title\">{{toast.title | translate}}</span>\n    <br />\n    <span  class=\"toast-msg\">{{toast.msg |translate}}</span>\n  </div>\n</div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/core/toast/toast.component.html
// module id = 571
// module chunks = 9